module.exports = __webpack_public_path__ + "static/media/ucon6.8f911893.JPG";